<template>
    <div>
        <p class="label">{{ label }}</p>

        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" :loading="isLoading" />
<!--        <v-autocomplete-->
<!--            hide-details-->
<!--            v-model="pickedIds"-->
<!--            :items="items"-->
<!--            item-value="id"-->
<!--            item-text="name"-->
<!--            multiple-->
<!--            outlined-->
<!--            hide-no-data-->
<!--            :loading="isLoading"-->
<!--            @change="onChange"-->
<!--            v-bind="$attrs"-->
<!--        >-->
<!--            <template v-slot:selection="{ item, index }">-->
<!--                <span-->
<!--                        v-if="index === 0"-->
<!--                        class="grey&#45;&#45;text caption"-->
<!--                >-->
<!--                    <template v-if="pickedIds.length === 1">{{ pickedIds.length }} item</template>-->
<!--                    <template v-else>{{ pickedIds.length }} items</template>-->
<!--                </span>-->
<!--            </template>-->
<!--        </v-autocomplete>-->
<!--        <v-flex xs12 sm12 md12 v-if="pickedItems.length > 0">-->
<!--            <v-flex xs12>-->
<!--                <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">-->
<!--                    <template v-for="(item, index) in pickedItems">-->
<!--                        <v-chip-->
<!--                                close-icon="$close"-->
<!--                                close-->
<!--                                outlined-->
<!--                                label-->
<!--                                color="#202020"-->
<!--                                :key="item.id"-->
<!--                                class="mr-2 my-1"-->
<!--                                @click:close="unpick(index)"-->
<!--                        >-->
<!--                            <span class="body-2">{{ item.name }}</span>-->
<!--                        </v-chip>-->
<!--                    </template>-->
<!--                </v-card>-->
<!--            </v-flex>-->
<!--        </v-flex>-->
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import RegionService from '@/services/region.service.js';

  export default {
    name: "RegionMultiplePickerInput",
    components: {
      MultiplePickerInput
    },
    props: {
      value: { type: Array, default: () => []},
      label: {type: String, default: 'Région(s)'},
      countryIds: { type: Array, default: () => []},
      taskEdit: { type: Boolean, default: false }
    },
    data() {
      return {
        items: [],
        isLoading: false,
        search: null,
        pickedIds: [],
        timeoutHandler: null,
      }
    },
    computed: {
      pickedItems() {
        const _this = this;

        return _this.pickedIds.map((id) => {
          return _this.items.find((item) => {
            return item.id === id;
          })
        });
      },
    },
    methods: {
      loadListItem() {
        const _this = this;
        if (this.items.length > 0 || !this.countryIds.length || this.isLoading) return;

        this.isLoading = true;

        RegionService.getListByStudent(this.countryIds)
          .then(({data}) => {
            _this.items = data;
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      // unpick(index) {
      //   this.pickedIds.splice(index, 1);
      //
      //   this.$emit('input', this.pickedIds);
      // },
      // onChange(value) {
      //   this.$emit('input', value);
      // },
      onInput(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      countryIds: {
        immediate: true,
        handler(value) {
          const _this = this;
          this.items = [];
          this.pickedIds = [];

          //check task edit 
          if(!this.taskEdit){
            this.$emit('input', []);
          }else{
            this.$emit('resetTask', false);
          }

          if (Array.isArray(value) && value.length > 0) {
            clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              _this.loadListItem();
            }, 1000);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
